<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.75 16.625L3.75 16.625" stroke="white" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    <path d="M20.25 16.625L15.75 16.625" stroke="white" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    <path d="M6.75 8.37507L3.75 8.375" stroke="white" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    <path d="M20.25 8.375L9.75 8.37507" stroke="white" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    <path d="M9.75 6.125V10.625" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.75 18.875V14.375" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>